class VwPatolojiTaleponaysonucDTO {
    id: number = 0;
    orderPatolojiId?: number = null;
    orderDetayId?: number = null;
    orderId?: number = null;
    protokolNo?: number = null;
    protokolOnek?: string = "";
    protokolYil?: number = null;
    protokolSira?: number = null;
    revizeno?: number = null;
    raportip?: number = null;
    hastaAdiSoyadi?: string = "";
    muracaatId?: number = null;
    kimlikId?: number = null;
    kurumId?: number = null;
    islemadi?: string = "";
    organizasyonAdi?: string = "";
    alinmaTarih?: string = null;
    alinmaSekliId?: number = null;
    protokolGosterim?: string = "";
}
export default VwPatolojiTaleponaysonucDTO;